import React, { FunctionComponent } from "react";

import { IField } from "@/types/hubspot";
import FormFieldError from "../fieldError";

type Props = {
  field: IField;
  callback: Function;
};
const FormTextArea: FunctionComponent<Props> = ({ field, callback }) => {
  const validateField = (value: string) => {
    callback({
      ...field,
      value: value,
    });
  };

  return (
    <div className={`mb-5 ${field.hidden ? "hidden" : ""}`}>
      <label
        htmlFor={field.name}
        className={`mb-2 block text-sm font-medium${field.error ? "text-red-700" : ""}`}
      >
        {field.label}
        {!field.required ? " (optional)" : ""}
      </label>
      <textarea
        id={field.name}
        name={field.name}
        rows={13}
        placeholder=""
        required={field.required}
        hidden={field.hidden}
        aria-required={field.required}
        aria-invalid={field.error ? true : false}
        aria-errormessage={`error-${field.name}`}
        onBlur={(event) => validateField(event.target.value)}
        onChange={(event) => field.error && validateField(event.target.value)}
        className={`block w-full rounded-lg border ${field.error ? "border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-red-500 focus:ring-red-500" : "border-gray-300 bg-gray-50 text-gray-900 focus:border-blue-500 focus:ring-blue-500"} p-2.5`}
      />
      <FormFieldError field={field} error={field.error} />
    </div>
  );
};

export default FormTextArea;
